// extracted by mini-css-extract-plugin
module.exports = {"view":"template_view__3wv2L","loading":"template_loading__1MRVm","withoutSpace":"template_withoutSpace__DEf6c","animated":"template_animated__1zE0z"};